import { call, put, takeEvery } from 'redux-saga/effects';

import Actions from '../action';
import Axios from 'axios';
import { message } from 'antd';
import { API_DOMAIN } from '@constants/app-constants';

export function* contactInfoServiceWorker(companyId) {
	try {
		let companyId = 0;
		const uri = `${API_DOMAIN}​/Contact/EAA660D4-E4EE-EB11-A7AD-0050F2F16E72​/update`;
		const res = yield call(Axios.get, uri);
		console.log('res', res);
		yield put(Actions.creators.setContactInfoSuccess(res));
	} catch (err) {
		message.error('Network Error');
		yield put(Actions.creators.setContactInfoError());
	}
}
export function* getContactInfoServiceWorker() {
	console.log('saga');
	try {
		let companyId = 'EAA660D4-E4EE-EB11-A7AD-0050F2F16E72';
		console.log('cmpid', companyId);
		const uri = `${API_DOMAIN}/Contact/` + companyId;
		let res = yield call(Axios.get, uri);
		console.log('resssss', res);
		yield put(Actions.creators.getContactInfoSuccess(res));
	} catch (err) {
		message.error('Network Error');
		yield put(Actions.creators.getContactInfoError());
	}
}

export default function* contactInfosWatcher() {
	console.log('takeEvery');
	yield takeEvery(Actions.types.SAVE_CONTACT_INFO_DATA_START, contactInfoServiceWorker);
	yield takeEvery(Actions.types.GET_CONTACT_INFO_DATA_START, getContactInfoServiceWorker);
}
